export default function isProduction() {
  return window.location.hostname === 'prod.prism.jdplc.com';
}
